import React from "react";
import "./Services.css";

const services = [
  {
    title: "Rapid City Transfer",
    description: "We will bring you quickly and comfortably to anywhere in your city.",
    image: "_services-1.png",
  },
  {
    title: "Hotel Pickup",
    description: "Visiting the city? We are here at your service for pick up and drop at your hotel.",
    image: "_services-2.png",
  },
  {
    title: "Airport Pickup/Drop",
    description: "Contact us for Airport pick up / drop for you or your guests.",
    image: "_services-3.png",
  },
  {
    title: "Baggage Transport",
    description: "Have extra luggage? We will arrange the perfect cab with cabin space and carriers for your needs.",
    image: "_services-4.png",
  },
];

const Services = () => {
  return (
    <section className="services-section" id="services">
      <div className="container">
        <h2 className="services-header">What We Offer</h2>
        <div className="services-grid">
          {services.map((service, index) => (
            <div className="services-card" key={index}>
              <div className="services-image">
                <img src={service.image} alt={service.title} />
              </div>
              <div className="services-content">
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
